module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_4.d983a973.png";